<template>
    <div>
        <div class="navbar relstive" :class="{
            immersive: immersive === 'true',
            'whitebg-navbar': immersive === 'true' ? showWhiteBg : true,
            'show-navbar': immersive !== 'true' ? false : showNavbar,
            'show-menu': showMenu,
            down: immersive === 'true' ? false : direction === 'down',
            up: immersive === 'true' ? false : direction === 'up',
            animation:
                immersive === 'true' ? true : (!above72 && direction === 'down') || above72,
        }" style="z-index:9;" :style="{
    transform: immersive === 'true' ? 'unset' : translateYVal,
}">
            <div class="menu-mask" @click="toggleMenu"></div>
            <div class="nav-area-wrap" :style="{
                height: showMenu ? `${menuHeight}px` : clientWidth < 992 ? `64px` : `72px`,
            }">
                <div class="b-container" ref="menuContainer">
                    <div class="nav-area">
                        <!-- 修改logo区域：简化结构并缩小 -->
                        <div class="logo-area">
                            <div class="logo ml-md" @click="onClickMenu('top')">
                                <!-- 使用更简洁的logo显示 -->
                                <img class="logo" :src="immersive === 'true' && !showWhiteBg && !showMenu ? LogoWhite : Logo" 
                                     mode="aspectFit" />
                            </div>
                            <div class="pointer nav-menu mr-md row center v-center" @click="toggleMenu">
                                <div class="menu-icon2" style="width:24px; height:24px; margin-right:4px;">
                                    <span class="control-icon"></span>
                                    <span class="control-icon"></span>
                                    <span class="control-icon"></span>
                                </div>
                            </div>
                        </div>
                        
                        <!-- 修改导航区域：增加可用空间 -->
                        <div :class="[clientWidth >= 992 ? 'nav-area-end' : 'nav-area-end-mobile']">
                            <div class="nav-list-container">
                                <div class="nav-list">
                                    <ul>
                                        <li :class="{ active: activeNav === 'home' }">
                                            <span class="nav-item pointer" @click="onClickMenu('top')">首页</span>
                                        </li>
                                        <li :class="{active: activeNav === 'content3d'}">
                                            <span class="nav-item pointer" @click="onClickMenu('b')">应用场景</span>
                                        </li>
                                        <li :class="{ active: activeNav === 'gameintro' }">
                                            <span class="nav-item pointer" @click="onClickMenu('c')">
                                                基础功能
                                            </span>
                                        </li>
                                        <li :class="{
                                            active: activeNav === 'zxservice',
                                        }">
                                            <span class="nav-item pointer" @click="onClickMenu('d')">特色业务</span>
                                        </li>
                                        <li :class="{ active: activeNav === 'shopintro' }">
                                            <span class="nav-item pointer" @click="onClickMenu('e')">
                                                专属商城
                                            </span>
                                        </li>
                                        <li :class="{ active: activeNav === 'company' }">
                                            <span class="nav-item pointer" @click="onClickMenu('f')">
                                                合作客户
                                            </span>
                                        </li>
                                        <li :class="{ active: activeNav === 'contact' }">
                                            <span class="nav-item pointer" @click="onClickMenu('g')">
                                                联系我们
                                            </span>
                                        </li>
                                        <li :class="{ active: activeNav === 'create' }">
                                            <span class="nav-item1 pointer" @click="onClickMenu('h')">
                                                登录
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="social-media">
                                <div class="icon-44 mr-md">
                                    <div @click="toggleQrcode" class="social-media-item pointer">
                                        <i class="iconfont icon-wechat"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="immersive !== 'true'" :style="{ height: clientWidth < 992 ? `64px` : `72px` }"></div>
    </div>
</template>

<script>
import { Logo, LogoWhite } from '@/constants/pics';

export default {
    name: 'navbar',

    components: {},

    props: ['immersive', 'toggleQrcode', 'scrollTop', 'scrollTo', 'direction', 'activeNav'],

    data() {
        return {
            Logo,
            LogoWhite,

            showMenu: false,
            showDropdown: false, // PC端下拉菜单显示
            showMobileDropdown: false, // 移动端下拉菜单显示

            menuHeight: 0,
            clientWidth: 0,
        };
    },

    computed: {
        showWhiteBg() {
            if (this.scrollTop <= 36) {
                return false;
            }
            return true;
        },

        above72() {
            if (this.scrollTop >= 0 && this.scrollTop < 72) {
                return false;
            }
            return true;
        },

        showNavbar() {
            if (this.above72 && !this.showMenu) {
                if (this.direction === 'down') {
                    return true;
                }
                if (this.direction === 'up' && this.scrollTop <= 0) {
                    return true;
                }
                return false;
            }
            return true;
        },

        translateYVal() {
            if (this.scrollTop <= 72) {
                return `translateY(${0 - this.scrollTop}px)`;
            }
            return 'translateY(-100%)';
        },
    },

    created() { },

    mounted() {
        // 01
        const menuHeight = this.$refs.menuContainer.clientHeight || 0;
        this.menuHeight = menuHeight;

        // 02
        const { clientWidth } = document.documentElement;
        this.clientWidth = clientWidth;

        let resizeTag = true;
        window.addEventListener('resize', () => {
            if (resizeTag) {
                // 01
                const menuHeight = this.$refs.menuContainer.clientHeight || 0;
                this.menuHeight = menuHeight;

                // 02
                const { clientWidth } = document.documentElement;
                this.clientWidth = clientWidth;

                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                }, 100);
            }
        });
    },

    activated() { },

    deactivated() { },

    methods: {
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },

        onClickMenu(val) {
            this.scrollTo(val);
            if (this.showMenu) {
                this.showMenu = false;
            }
        },
        
        // 切换免费试用下拉菜单
        toggleFreeTrialDropdown() {
            if (this.clientWidth >= 992) {
                // PC端点击时不处理，由hover控制
                return;
            } else {
                // 移动端点击切换显示
                this.showMobileDropdown = !this.showMobileDropdown;
            }
        },
        
        // 跳转到婚礼活动页面
        goToWeddingPage() {
            // 这里替换为您的婚礼活动链接
            window.open('https://game.xiliji.tech/#/home?token=51', '_blank');
            this.showDropdown = false;
            this.showMobileDropdown = false;
        },
        
        // 跳转到会议活动页面
        goToMeetingPage() {
            // 这里替换为您的会议活动链接
            window.open('https://game.xiliji.tech/#/home?token=51', '_blank');
            this.showDropdown = false;
            this.showMobileDropdown = false;
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/stylesheets/modules/all';

.menu-icon {
    display: block;
    width: 44px;
    height: 44px;
    position: relative;
}

.menu-icon span {
    position: absolute;
    width: 24px;
    height: 2px;
    top: 21px;
    left: 10px;
    background: #fff;
    border-radius: 1px;
    will-change: transform;
    transition: all 0.2s linear;
}

.menu-icon:before {
    content: '';
    display: block;
    position: absolute;
    width: 24px;
    height: 2px;
    border-radius: 1px;
    top: 11px;
    left: 10px;
    background: #fff;
    will-change: transform;
    transition: all 0.2s linear;
    transform-origin: 50% 50%;
}

.menu-icon:after {
    content: '';
    display: block;
    position: absolute;
    width: 24px;
    height: 2px;
    border-radius: 1px;
    bottom: 11px;
    left: 10px;
    background: #fff;
    will-change: transform;
    transition: all 0.2s linear;
    transform-origin: 50% 50%;
}

.show-menu .menu-icon {
    display: block;
    width: 44px;
    height: 44px;
    position: relative;
}

.show-navbar .menu-icon span,
.show-navbar .menu-icon:before,
.show-navbar .menu-icon:after {
    background: #fff;
}

.show-navbar.whitebg-navbar .menu-icon span,
.show-navbar.whitebg-navbar .menu-icon:before,
.show-navbar.whitebg-navbar .menu-icon:after {
    background: #000;
}

.show-menu .menu-icon span {
    position: absolute;
    width: 24px;
    height: 2px;
    border-radius: 1px;
    top: 21px;
    left: 10px;
    background: #000;
    opacity: 0;
}

.show-menu .menu-icon:before {
    content: '';
    display: block;
    position: absolute;
    width: 28px;
    height: 2px;
    border-radius: 1px;
    top: 21px;
    left: 8px;
    background: #000;
    transform: rotate(45deg);
    transform-origin: 50% 50%;
}

.show-menu .menu-icon:after {
    content: '';
    display: block;
    position: absolute;
    width: 28px;
    height: 2px;
    border-radius: 1px;
    bottom: 21px;
    left: 8px;
    background: #000;
    transform: rotate(-45deg);
    transform-origin: 50% 50%;
}

// PC端样式
@media (min-width: 992px) {
    // navbar
    .navbar {
        will-change: transform;
    }

    .whitebg-navbar {
        background: #fff;
    }

    .nav-area {
        margin: 0 -15px;
        height: 72px;
        z-index: 2;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    // 缩小logo区域
    .logo-area {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        min-width: 100px;
        max-width: 120px;
        flex-shrink: 0;
        padding-right: 10px;
    }

    .logo {
        display: block;
        cursor: pointer;
        width: 100px !important;
        height: 36px !important;
        object-fit: contain;
    }

    .logo-new {
        width: 36px !important;
        height: 36px !important;
    }

    .nav-menu {
        display: none !important;
    }

    // 导航区域容器
    .nav-area-end {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: calc(100% - 120px);
        min-width: 0;
        flex: 1;
        gap: 10px;
    }

    // 导航列表容器 - 确保按钮在一行
    .nav-list-container {
        flex: 1;
        min-width: 0;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        
        &::-webkit-scrollbar {
            display: none;
        }
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .nav-list {
        display: flex;
        flex-direction: row;
        align-items: center;
        white-space: nowrap;
        flex-wrap: nowrap;
        max-width: 100%;
        width: max-content;
        padding: 0 10px;
        
        &::-webkit-scrollbar {
            display: none;
        }
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .nav-list ul {
        display: flex;
        flex-direction: row;
        white-space: nowrap;
        padding: 0;
        margin: 0;
        list-style: none;
        flex-wrap: nowrap;
        gap: 4px;
    }

    .nav-list li {
        display: inline-block;
        flex-shrink: 0;
        position: relative;
    }

    .nav-list li.active {
        position: relative;
        font-weight: bold;
    }

    .nav-list li.active:before {
        content: '';
        position: absolute;
        display: block;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 12px;
        height: 3px;
        border-radius: 2px;
        background: #fff;
    }

    .nav-list li .nav-item {
        cursor: pointer;
        color: #ff3355;
        text-decoration: none;
        white-space: nowrap;
        display: block;
        padding: 10px 8px;
        font-size: 14px;
        line-height: 1.2;
    }
    
    .nav-item1 {
        color: white;
        padding: 6px 10px !important;
        background: #ff3355;
        border-radius: 4px;
        font-size: 14px;
        white-space: nowrap;
        display: inline-block;
        margin-left: 4px;
    }

    .whitebg-navbar .nav-list li.active:before {
        background: #ff3355;
    }

    .whitebg-navbar .nav-list li .nav-item {
        color: #ff3355;
        text-decoration: none;
    }

    .social-media {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        flex-shrink: 0;
        min-width: 50px;
    }

    .social-media-item {
        text-decoration: none;
        cursor: pointer;
    }

    .social-media-item i {
        color: #fff;
        font-size: 26px;
    }

    .whitebg-navbar .social-media-item i {
        color: #666;
    }
}

// 移动端样式
@media (max-width: 991px) {
    .show-menu .menu-mask {
        display: block;
    }

    .logo {
        width: 90px !important;
        height: 32px !important;
    }

    // navbar
    .navbar {
        will-change: transform;
    }

    .show-menu {
        height: 100%;
    }

    .nav-area {
        margin: 0 -15px;
        height: auto;
        z-index: 2;
        display: block;
    }

    .whitebg-navbar .nav-area-wrap,
    .show-menu .nav-area-wrap {
        position: relative;
        z-index: 2;
        background: #fff;
    }

    .nav-area-wrap {
        height: 64px;
        opacity: 1;
        overflow: hidden;
        background: transparent;
        transition: all 0.2s linear;
    }

    .show-menu .nav-area-wrap {
        height: auto;
        opacity: 1;
        overflow: hidden;
        display: flex;
        flex-direction: row;
    }

    .show-navbar .nav-area-wrap .nav-list,
    .show-navbar .nav-area-wrap .social-media {
        opacity: 0;
        transition: opacity 0.2s linear;
    }

    .show-navbar.show-menu .nav-area-wrap .nav-list,
    .show-navbar.show-menu .nav-area-wrap .social-media {
        opacity: 1;
    }

    .menu-mask {
        opacity: 0;
        transition: all 0.5s linear;
    }

    .show-menu .menu-mask {
        opacity: 1;
    }

    .logo-area {
        min-height: 64px;
        padding: 0 4px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .logo {
        display: block;
    }

    .nav-menu {
        display: block;
        color: #fff;
    }

    .whitebg-navbar .nav-menu,
    .show-menu .nav-menu {
        color: #000;
    }

    // 移动端导航列表 - 保持水平滚动
    .nav-list {
        display: flex;
        flex-direction: row;
        padding: 12px 0;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
        
        &::-webkit-scrollbar {
            display: none;
        }
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .nav-list ul {
        display: flex;
        flex-direction: row;
        white-space: nowrap;
        padding: 0 20px;
        margin: 0;
        list-style: none;
        flex-wrap: nowrap;
        gap: 10px;
    }

    .nav-list li {
        display: inline-block;
        flex-shrink: 0;
        padding: 0;
        margin: 0;
        font-size: 14px;
        border-bottom: none;
        
        &:last-child {
            border-bottom: none;
        }
    }

    .nav-list li.active {
        position: relative;
        display: inline-block;
        padding: 0;
        font-size: 14px;
        font-weight: bold;
    }

    .nav-list li.active:before {
        content: '';
        position: absolute;
        display: block;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 12px;
        height: 3px;
        border-radius: 2px;
        background: #ff3355;
    }

    .nav-list li .nav-item {
        cursor: pointer;
        display: block;
        padding: 8px 12px;
        color: #fff;
        text-decoration: none;
        white-space: nowrap;
    }

    .whitebg-navbar .nav-list li.active,
    .show-menu .nav-list li.active {
        // border-left: 2px solid #ff3355;
    }

    .whitebg-navbar .nav-list li .nav-item,
    .show-menu .nav-list li .nav-item {
        color: #333;
        text-decoration: none;
    }

    .social-media {
        padding: 12px 20px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }

    .show-menu .nav-area .nav-list {
        display: flex !important;
        flex-direction: row;
        white-space: nowrap;
    }

    .show-menu .nav-area .social-media {
        display: flex;
    }

    .social-media-item {
        text-decoration: none;
    }

    .social-media-item i {
        color: #fff;
        font-size: 28px;
    }

    .whitebg-navbar .social-media-item i,
    .show-menu .social-media-item i {
        color: #666;
    }

    // 移动端菜单图标
    .menu-icon2 {
        width: 24px;
        height: 24px;
    }

    .menu-icon2 .control-icon {
        display: block;
        padding-top: 3px;
        padding-bottom: 3px;
        transition: all 0.3s ease;
    }

    .menu-icon2 .control-icon:before {
        content: '';
        display: block;
        height: 2px;
        width: 24px;
        background-color: #fff;
        border-radius: 1px;
        transition: transform 0.3s ease 0.2s, background-color 0.4s ease 0s;
    }

    .whitebg-navbar .menu-icon2 .control-icon:before {
        background-color: #000;
    }

    .show-menu .menu-icon2 .control-icon:nth-child(2) {
        opacity: 0;
    }

    .show-menu .menu-icon2 .control-icon:nth-child(1) {
        transform: translateY(8px);
    }

    .show-menu .menu-icon2 .control-icon:nth-child(1):before {
        transform: rotate(45deg);
    }

    .show-menu .menu-icon2 .control-icon:nth-child(3) {
        transform: translateY(-8px);
    }

    .show-menu .menu-icon2 .control-icon:nth-child(3):before {
        transform: rotate(-45deg);
    }

    .show-menu .menu-icon2 .control-icon:before {
        background-color: #000;
    }

    // 移动端导航区域
    .nav-area-end-mobile {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    
    // 移动端导航列表容器
    .nav-list-container {
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        
        &::-webkit-scrollbar {
            display: none;
        }
        scrollbar-width: none;
        -ms-overflow-style: none;
    }
}

// 响应式调整 - 针对不同屏幕尺寸进一步优化
@media (min-width: 1200px) {
    .logo-area {
        min-width: 120px;
    }
    
    .logo {
        width: 110px !important;
        height: 40px !important;
    }
    
    .nav-area-end {
        width: calc(100% - 130px);
    }
    
    .nav-list li .nav-item {
        font-size: 15px;
        padding: 10px 10px;
    }
    
    .nav-item1 {
        font-size: 15px;
        padding: 8px 12px !important;
    }
}

@media (min-width: 992px) and (max-width: 1199px) {
    .nav-list li .nav-item {
        font-size: 13px;
        padding: 10px 6px;
    }
    
    .nav-item1 {
        font-size: 13px;
        padding: 5px 8px !important;
    }
}

@media (min-width: 992px) and (max-width: 1100px) {
    .logo {
        width: 90px !important;
        height: 32px !important;
    }
    
    .logo-area {
        min-width: 90px;
    }
    
    .nav-area-end {
        width: calc(100% - 100px);
    }
    
    .nav-list li .nav-item {
        font-size: 12px;
        padding: 10px 4px;
    }
    
    .nav-item1 {
        font-size: 12px;
        padding: 4px 6px !important;
    }
}

@media (max-width: 768px) {
    .nav-list li .nav-item {
        font-size: 13px;
        padding: 8px 10px;
    }
    
    .nav-item1 {
        font-size: 13px;
        padding: 6px 10px !important;
    }
}

@media (max-width: 576px) {
    .logo {
        width: 80px !important;
        height: 28px !important;
    }
    
    .nav-list ul {
        padding: 0 10px;
        gap: 8px;
    }
    
    .nav-list li .nav-item {
        font-size: 12px;
        padding: 8px 8px;
    }
    
    .nav-item1 {
        font-size: 12px;
        padding: 5px 8px !important;
    }
}

// 通用样式
.navbar {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 9;
}

.menu-mask {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 0.62);
}

// home
.navbar.immersive {
    // TODO
    // transform: translateY(-100%) !important;
}

.navbar.show-navbar {
    transform: translateY(0) !important;
}

// !home
.navbar.down {
    transform: rotateY(0) !important;
}

.navbar.up {
    transform: rotateY(-100%) !important;
}

// common
.navbar.show-menu {
    transform: rotateY(0) !important;
}

.animation {
    transition: all 0.2s linear;
}

// 确保导航列表不换行的通用类
.no-wrap {
    white-space: nowrap;
    flex-wrap: nowrap;
}

// 滚动条隐藏通用类
.scrollbar-hidden {
    &::-webkit-scrollbar {
        display: none;
    }
    scrollbar-width: none;
    -ms-overflow-style: none;
}
</style>